import React, { Component } from 'react';
import { Grid, Segment, Comment, Header, Input, Button, Loader, Message } from 'semantic-ui-react';
import { connect } from 'react-redux';
import _ from 'lodash';
import Moment from 'moment';

import {
   getUserProfilePhoto,
   verifyChatCall,
} from "../../actions";

import {
    receiveNewMessage,
    initMenu,
    selectMenuItem,
    stopTalkingToJoey,
    sendJoeyTextMessage,
    talkToJoey,
    sendJoeyAttachmentMessage,
} from './chat_api';
import ChatSpeechMenuRedirect from './speech_menu_redirect';
import {SpeechBubble} from './speech_bubble';

class Conversation extends Component {
    constructor(props) {
        super(props);

        this.state = {
            dateTime: new Date(),
            roomId: null,
            messages: [],
            messageComponents: [],
            initMenu: false,
            menuItems: [],
            loaded: false,
            hasSelectedMenu: false,
            hasOpenChat: false,
            isClosedByUser: false,
            isUploadingAttachment: false,
        };

    }
    componentDidMount() {
        // this.inputRef.focus();
        const { accessToken } = this.props.user;

        const queryType = this.props.queryString.type;
        const queryTransactionNo = this.props.queryString.id;
        var queryTransactionNoMessage = '';
        console.log("is it access here.")
        this.props.verifyChatCall(accessToken);
        let optionalParameters = null;
        let type = null;

        if (queryType && queryTransactionNo) {
            if (queryType === 'inpclaim' || queryType === 'outclaim') {
                type = '2';
                optionalParameters = { claimId: queryTransactionNo };
                queryTransactionNoMessage = 'I want to check the status for claim id: ' + queryTransactionNo
            } else if (queryType === 'elog') {
                type = '4';
                optionalParameters = { elogId: queryTransactionNo };
                queryTransactionNoMessage = 'I want to check the status for eLOG id: ' + queryTransactionNo
            }
        }

        talkToJoey(null, accessToken, (queryTransactionNoMessage.length > 0 ? 'talkToJoey':null), (result, error) => {
            this.setState({loaded: true});
            if (result) {
                if (result.initMenu && result.initMenu === true) {
                    console.log('wait for initMenu call');
                }
                else {
                    const {previousMessages, roomId} = result;
                    const newSpeechBubbleArray = _.map(previousMessages, (msg) => <SpeechBubble key={msg.id} user={this.props.user} message={msg} profilePhoto={this.props.profilePhoto}/>)
                    this.setState({
                        messages: previousMessages,
                        messageComponents: this.state.messageComponents.concat(newSpeechBubbleArray),
                        roomId
                    });
                }

                if (queryTransactionNoMessage.length > 0) {
                    sendJoeyTextMessage(queryTransactionNoMessage, accessToken, () => console.log('message sent-queryTransactionNoMessage.length'));
                }
            }

            if (error && error.hasOpenChat) {
                // just display has open chat regardless of the error.
                // this.setState({hasOpenChat: true});
                sendJoeyTextMessage(queryTransactionNoMessage, accessToken, () => console.log('message sent-queryTransactionNoMessage.error.hasOpenChat'));
            }
        });

        initMenu((menuItems) => {
            console.log('initMenuNow', menuItems);
            this.setState({initMenu: true, menuItems: menuItems.menu});
        });

        receiveNewMessage((msg) => {
            console.log('receiveNewMessage', msg);
            const newSpeechBubbleComponent = <SpeechBubble key={msg.messageId} user={this.props.user} message={msg} profilePhoto={this.props.profilePhoto}/>;
            this.setState({
                messageComponents: this.state.messageComponents.concat(newSpeechBubbleComponent)
            });
        })

    }
    renderSpeechBubbles() {
        return this.state.messages.map((message) => {
            return (
                <SpeechBubble message={message} myName={this.props.user.name} user={this.props.user} key={message.createdAt} profilePhoto={this.props.profilePhoto}/>
            );
        })
    }
    handleRef = (c) => {
        this.inputRef = c
    }
    handleSendMessageClick = (e) => {
        e.preventDefault();
        const messageText = this.inputRef.inputRef.value ? this.inputRef.inputRef.value : this.inputRef.inputRef.current.value;
        const {accessToken} = this.props.user;
        if (messageText) {
            sendJoeyTextMessage(messageText, accessToken, () => console.log('message sent-handleSendMessageClick'));
            if (this.inputRef.inputRef.current.value) {
                this.inputRef.inputRef.current.value = '';
            } else {
                this.inputRef.inputRef.value = '';
            }
        }
        this.inputRef.focus();
    }
    redirectPageToUrl = (newUrl) => {
        this.props.history.push(newUrl);
    }
    handleMenuItemClick = (menuId) => {
        this.setState({hasSelectedMenu: true});
        const {accessToken} = this.props.user;
        selectMenuItem(menuId, accessToken, (result, error) => {
            if (result) {
                const {actionType, actionParam, message} = result.action;
                if (actionType === 'redirect-button') {
                    const newMessageComponent = <ChatSpeechMenuRedirect key={new Date().valueOf().toString()} { ...result.action } redirectPageToUrl={this.redirectPageToUrl}/>;
                    this.setState({messageComponents: this.state.messageComponents.concat(newMessageComponent)});
                } else if (actionType === 'talkToJoey') {
                    talkToJoey(actionParam.optionalParameters, accessToken, actionParam.type, (result, error) => {
                        console.log(result, error);
                        if (result) {
                            const menuAnswerMEssage = {
                                createdAt: new Date().valueOf(),
                                message: message,
                                messageId: new Date().valueOf().toString(),
                                type: 1,
                                userId: 'Rainbow',
                                userName: 'Joey'
                            };
                            const newMessageComponent = <SpeechBubble key={menuAnswerMEssage.messageId} message={menuAnswerMEssage} user={this.props.user} />;
                            this.setState({
                                roomId: result.roomId,
                                messageComponents: this.state.messageComponents.concat(newMessageComponent)
                            });
                        }
                    });
                }
            }
        });
    }
    renderInitMenuSpeechBubble() {
        if (this.state.initMenu === true) {
            return (
                <Comment>
                    <Comment.Avatar src='https://incomeapp.mhc.asia/static/app_logo.png' />
                    <Comment.Content>
                        <Comment.Author>Joey</Comment.Author>
                        <Comment.Metadata>
                            <div>{ Moment().format('DD MMM YYYY HH:MM:SS') }</div>
                        </Comment.Metadata>
                        <Comment.Text>
                            Hi, how can I help you today?
                        </Comment.Text>
                        {
                            _.map(this.state.menuItems, (menuItem) => {
                                return (
                                    <Button
                                        key={menuItem.id}
                                        fluid
                                        onClick={() => this.handleMenuItemClick(menuItem.id)}
                                        disabled={this.state.hasSelectedMenu}
                                    >
                                        {menuItem.message}
                                    </Button>
                                );
                            })
                        }
                    </Comment.Content>
                </Comment>
            );
        }
    }
    handleCloseChatClick = () => {
        const {accessToken} = this.props.user;
        stopTalkingToJoey(accessToken, (result, error) => {
            console.log(result, error);
            if (result) {
                this.setState({roomId: null, isClosedByUser: true});
            }
        });
    }
    handleUploadAttachment = (e) => {
        console.log(e, e.target.files);
        const {accessToken} = this.props.user;
        let files = e.target.files;
        let file = files[0];
        this.setState({isUploadingAttachment: true});
        let reader = new FileReader();

        reader.onload = () => {
            const base64DataOutput = reader.result;
            sendJoeyAttachmentMessage(base64DataOutput, accessToken, (result, error) => {
                console.log(result, error);

                this.setState({isUploadingAttachment: false});
            })
        };

        reader.readAsDataURL(file);

    }
    render() {
        if (this.state.loaded === false) {
            return <Loader active />;
        }
        if (this.state.hasOpenChat === true) {
            return (
                <Message negative>
                    <Message.Header>
                        You have a on-going chat request with our adminstrators.
                    </Message.Header>
                    <p>
                        To raise a new request, please click <Button onClick={() => { window.location.href = '/app/askjoey'; }}>here</Button> to view the on-going request and close it before opening a new request.
                    </p>
                </Message>
            );
        }
        return (
            <Grid.Column>
                <Header as='h4' attached='top' block>
                    Conversation Log
                </Header>
                {
                    (this.state.isClosedByUser === true) ?
                    (
                        <Message negative>
                            <Message.Header>
                                Your request is now closed
                            </Message.Header>
                            Please click <Button onClick={() => { window.location.href = '/app/askjoey'; }}>here</Button> to open the chat menu again.
                        </Message>
                    )
                    :
                    null
                }
                <Button
                    attached
                    onClick={this.handleCloseChatClick}
                    disabled={!this.state.roomId}
                >
                    Close this conversation
                </Button>
                <Segment attached>
                    <Comment.Group>
                        { this.renderInitMenuSpeechBubble() }
                        { _.map(this.state.messageComponents, (message) => message) }
                    </Comment.Group>
                    <form onSubmit={this.handleSendMessageClick}>
                        <Grid>
                            <Grid.Row>
                                <Grid.Column width={12}>
                                    <Input
                                        label={<Button type="submit" disabled={!this.state.roomId} >Send</Button>}
                                        ref={this.handleRef}
                                        labelPosition='right'
                                        disabled={!this.state.roomId}
                                    />
                                </Grid.Column>
                                <Grid.Column width={4}>
                                    <Button
                                        type="button"
                                        disabled={!this.state.roomId}
                                        onClick={() => this.fileInput.click()}
                                        loading={this.state.isUploadingAttachment}
                                    >
                                        Upload Attachment
                                    </Button>
                                    <input
                                        ref={element => this.fileInput = element}
                                        hidden
                                        type="file"
                                        onChange={(e)=>this.handleUploadAttachment(e)}
                                    />
                                </Grid.Column>
                            </Grid.Row>
                        </Grid>
                    </form>
                </Segment>
            </Grid.Column>
        );
    }
}

function mapStateToProps(state) {
    return {
        user: state.user.user,
        profilePhoto: state.user.profilePhoto,
    };
}

export default connect(mapStateToProps,{
    verifyChatCall,
})(Conversation);

/*
<form onSubmit={this.handleSendMessageClick}>
    <Input
        type="text"
        disabled={!this.state.roomId}
        ref={this.handleRef}
    >

        <Button type="submit" disabled={!this.state.roomId} >Send</Button>
        <Button
            type="button"
            disabled={!this.state.roomId}
            onClick={() => this.fileInput.click()}
            loading={this.state.isUploadingAttachment}
        >
            Upload Attachment
        </Button>
        <input
            ref={element => this.fileInput = element}
            hidden
            type="file"
            onChange={(e)=>this.handleUploadAttachment(e)}
        />
    </Input>
</form>
*/
